type Locale = 'es' | 'en' | 'pt';

const getLocaleStrings = (locale: Locale) => {
  if (locale === 'en') {
    return {
      description:
        'El Impostor is the best FREE online social deduction game where you must discover who the impostor is. Play with friends in real time in multiplayer mode or in-person in table mode. Prove your deduction skills and uncover the traitor.',
      keywords:
        'impostor, impostor online, social deduction game, social game, multiplayer, among us, free online game',
      inLanguage: 'en-US',
      countriesSupported: ['US', 'GB', 'CA', 'AU', 'NZ', 'IE'],
      featureList: [
        'Real-time multiplayer game',
        'Online mode with private rooms',
        'Table mode for in-person play',
        'Interactive voting system',
        'In-game chat during rounds',
        'Multiple unique characters',
        'Free and no registration',
        'Compatible with all devices'
      ],
      websiteDescription: 'El Impostor - The best FREE online social deduction game. Discover who the impostor is while playing with friends.',
      orgDescription: 'El Impostor is the leading social deduction platform for Spanish-speaking players. Play free online or in person.',
      slogan: 'Discover who the impostor is',
      areaServed: ['US', 'GB', 'CA', 'AU', 'Europe', 'LatAm'],
      availableLanguage: ['English', 'en']
    };
  }

  if (locale === 'pt') {
    return {
      description:
        'El Impostor é o melhor jogo online GRATUITO de dedução social em que você precisa descobrir quem é o impostor. Jogue com amigos em tempo real no modo multijogador ou presencial no modo mesa. Mostre suas habilidades de dedução e descubra o traidor.',
      keywords:
        'impostor, impostor online, jogo de dedução social, jogo social, multijogador, among us, jogo grátis online',
      inLanguage: 'pt-BR',
      countriesSupported: ['BR', 'PT'],
      featureList: [
        'Jogo multijogador em tempo real',
        'Modo online com salas privadas',
        'Modo mesa para jogar presencialmente',
        'Sistema de votação interativo',
        'Chat integrado durante o jogo',
        'Múltiplos personagens únicos',
        'Gratuito e sem registro',
        'Compatível com todos os dispositivos'
      ],
      websiteDescription: 'El Impostor - O melhor jogo online GRATUITO de dedução social. Descubra quem é o impostor jogando com amigos.',
      orgDescription: 'El Impostor é a principal plataforma de jogos de dedução social em português. Jogue grátis online ou presencialmente.',
      slogan: 'Descubra quem é o impostor',
      areaServed: ['BR', 'PT', 'Europa', 'América Latina'],
      availableLanguage: ['Portuguese', 'pt']
    };
  }

  return {
    description:
      'El Impostor es el mejor juego online GRATIS de deducción social donde debes descubrir quién es el impostor. Juega con amigos en tiempo real en modo multijugador o presencial en modo mesa. Demuestra tus habilidades de deducción y descubre al traidor.',
    keywords: 'el impostor, impostor online, juego deducción, juego social, multijugador, among us español',
    inLanguage: 'es-ES',
    countriesSupported: ['ES', 'MX', 'AR', 'CO', 'CL', 'PE', 'VE', 'EC', 'GT', 'BO'],
    featureList: [
      'Juego multijugador en tiempo real',
      'Modo online con salas privadas',
      'Modo mesa para jugar presencialmente',
      'Sistema de votación interactivo',
      'Chat integrado durante el juego',
      'Múltiples personajes únicos',
      'Gratuito y sin registro',
      'Compatible con todos los dispositivos'
    ],
    websiteDescription: 'El Impostor - El mejor juego online GRATIS de deducción social. Descubre quién es el impostor jugando con amigos.',
    orgDescription: 'El Impostor es la plataforma líder de juegos de deducción social en español. Juega gratis online o presencialmente.',
    slogan: 'Descubre quién es el impostor',
    areaServed: ['ES', 'MX', 'AR', 'CO', 'CL', 'PE', 'América Latina', 'España'],
    availableLanguage: ['Spanish', 'es']
  };
};

export const getStructuredData = (locale: Locale = 'es') => {
  const text = getLocaleStrings(locale);
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "El Impostor",
    "alternateName": ["Impostor Game", "El Impostor Game", "El Impostor Online"],
    "description": text.description,
    "url": "https://el-impostor.com",
    "applicationCategory": "Game",
    "applicationSubCategory": "Social Deduction Game",
    "genre": ["Social Deduction", "Party Game", "Multiplayer Game"],
    "operatingSystem": ["Web Browser", "Windows", "macOS", "Linux", "iOS", "Android"],
    "keywords": text.keywords,
    "inLanguage": text.inLanguage,
    "countriesSupported": text.countriesSupported,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "category": "Free to Play"
    },
    "author": {
      "@type": "Organization",
      "name": "El Impostor",
      "url": "https://el-impostor.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "El Impostor",
      "url": "https://el-impostor.com"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "featureList": text.featureList,
    "screenshot": "https://el-impostor.com/android-chrome-512x512.png"
  };
};

// Datos estructurados para el sitio web con navegación
export const getWebSiteStructuredData = (locale: Locale = 'es') => {
  const text = getLocaleStrings(locale);
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "El Impostor",
    "alternateName": ["El Impostor Game", "Impostor Online", "El Impostor Online"],
    "url": "https://el-impostor.com",
    "description": text.websiteDescription,
    "inLanguage": text.inLanguage,
    "copyrightYear": "2025",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://el-impostor.com/blog?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "sameAs": []
  };
};

// Datos estructurados de navegación del sitio (sitelinks)
export const getBreadcrumbStructuredData = (locale: Locale = 'es') => {
  const isEn = locale === 'en';
  const isPt = locale === 'pt';
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "SiteNavigationElement",
        "position": 1,
        "name": isEn ? 'Impostor Online Multiplayer' : isPt ? 'Impostor Multijogador Online' : 'El Impostor Multijugador Online',
        "description": isEn ? 'Play Impostor online for free with friends in real time' : isPt ? 'Jogue Impostor online grátis com amigos em tempo real' : 'Juega El Impostor online gratis con amigos en tiempo real',
        "url": "https://el-impostor.com/create"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 2,
        "name": isEn ? 'Impostor Table Mode' : isPt ? 'Impostor Modo Mesa' : 'El Impostor Modo Mesa',
        "description": isEn ? 'Play Impostor in person with physical cards' : isPt ? 'Jogue Impostor presencialmente com cartas físicas' : 'Juega El Impostor presencialmente con cartas físicas',
        "url": "https://el-impostor.com/table"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 3,
        "name": isEn ? 'Impostor Blog' : isPt ? 'Blog do Impostor' : 'Blog El Impostor',
        "description": isEn ? 'Guides, strategies, and tips to win in Impostor' : isPt ? 'Guias, estratégias e dicas para vencer no Impostor' : 'Guías, estrategias y consejos para ganar en El Impostor',
        "url": "https://el-impostor.com/blog"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 4,
        "name": isEn ? 'Contact' : isPt ? 'Contato' : 'Contacto',
        "description": isEn ? 'Contact us for questions about Impostor' : isPt ? 'Fale conosco para dúvidas sobre o Impostor' : 'Contáctanos para dudas sobre El Impostor',
        "url": "https://el-impostor.com/contact"
      }
    ]
  };
};

// Organización del juego
export const getOrganizationStructuredData = (locale: Locale = 'es') => {
  const text = getLocaleStrings(locale);
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "El Impostor",
    "legalName": "El Impostor Game",
    "alternateName": ["Impostor Game", "El Impostor Online"],
    "url": "https://el-impostor.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://el-impostor.com/android-chrome-512x512.png",
      "width": 512,
      "height": 512
    },
    "description": text.orgDescription,
    "foundingDate": "2024",
    "slogan": text.slogan,
    "knowsAbout": ["Juegos de deducción", "Juegos sociales", "Juegos multijugador", "Among Us", "Mafia", "Werewolf"],
    "areaServed": text.areaServed,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "url": "https://el-impostor.com/contact",
      "availableLanguage": text.availableLanguage
    },
    "sameAs": []
  };
};